import {fetcher} from "@framework/fetcher";

const updateInformationCart = async (body: any) => {
    return await fetcher({
        method: 'PUT',
        url: `/cart/`,
        body: body
    });
}
export default updateInformationCart
